import { Tab, Nav } from 'react-bootstrap';

import Watch from '@/pages/dashboard/sections/watch'
import Evaluate from '@/pages/dashboard/sections/evaluate'
import History from '@/pages/dashboard/sections/history'
import Fav from '@/pages/dashboard/sections/fav'
import MiniNav from '@/components/common/miniNav/miniNav'
import { addCurrentThemeClassToEle, makeFirstLetterCapsAndRemoveUnderScore } from "@/utils";
import { navigateToMainSite } from '@/utils/mainSiteNavigateFromIframe';


import './mobileViewStyle.css';
import '@/styles/commonContainer.css'
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import { useSafeAreaInsets } from '@/hooks/useSafeAreaInsets';



export default function MobileView(props: any) {

  const handleRedirectFromMiniNav = () => {
    const url = process.env.REACT_APP_USER_PANEL_URL;
    if (!url) return;
    navigateToMainSite(url);
  };

  const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);
 
  const { bottom: safeAreaBottom, topSafeComponent, bottomSafeComponent } = useSafeAreaInsets();
  return (
    // <div className='bg-[#F5F5F5] h-screen dashboardMain1 dashboardMain dashboardMainMobile flex flex-col'>
    <div className='commonContainer dashboardMobileMain'>
      {/* <MiniNav
        navItemName={props.activeKey}
        redirectTo={handleRedirectFromMiniNav}
      /> */}
      <Tab.Container activeKey={props.activeKey} onSelect={(k) => k && props.handleIntSetActiveKey(k)}>
        {/* <div className='flex-1 overflow-auto p-4'> */}
        <div className='dashboardMobileMain1'>
          <Tab.Content className=''>
            {topSafeComponent}
            {props.tabs.map((tab: any) => (
              <Tab.Pane eventKey={tab.key} key={tab.key}>
                {/* <p>You're viewing the <strong>{props.dashboard.tabs[tab.key]}</strong> tab.</p> */}
                {tab.key === "watch" &&
                  <Watch
                    activeKey={props.activeKey}
                  />
                }
                {tab.key === "evaluate" &&
                  <Evaluate
                    activeKey={props.activeKey}
                  />
                }
                {tab.key === "history" &&
                  <History
                    activeKey={props.activeKey}
                  />
                }
                {tab.key === "favorite" &&
                  <Fav
                    activeKey={props.activeKey}
                  />
                }
              </Tab.Pane>
            ))}
            {bottomSafeComponent}
          </Tab.Content>
        </div>

        <Nav
          variant="tabs"
          className={`navCon fixed bottom-0 w-full bg-white/80 border-t flex justify-around max-[560px]:gap-[20px] max-[420px]:gap-[0px] ${addCurrentThemeClassToEle(currentTheme, 'navCon')}`}
          style={{ paddingBottom: safeAreaBottom+ 'px' }}
        >
          {props.tabs.map((tab: any) => (
            <Nav.Item key={tab.key}>
              <Nav.Link
                eventKey={tab.key}
                // className={`flex flex-col items-center ${props.activeKey === tab.key ? 'text-primary' : 'text-dark'}`}
                className={`flex flex-col items-center`}
                onClick={(e) => {
                  if (tab.key === 'home') {
                    e.preventDefault();
                    const homeUrl = process.env.REACT_APP_E_MEDISKILL_WEB_APP;
                    if (homeUrl) {
                      navigateToMainSite(homeUrl);
                    }
                  }
                }}
              >
                <img
                  // src={props.activeKey === tab.key ? tab.hoverIcon : tab.defaultIcon}
                  src={props.getCurrentNavIconSrc(props.activeKey, tab)}
                  alt={`${props.dashboard.tabs[tab.key]} icon`}
                  className="navIcon mb-1 "
                  style={{
                    width: 'clamp(16px,3vw,19px)',
                    height: 'clamp(16px,3vw,19px)',
                  }}
                />
                <span className="navTitle" style={{
                  fontSize: 'clamp(10px,3vw,12px)',
                }}>
                  {makeFirstLetterCapsAndRemoveUnderScore(props.dashboard.tabs[tab.key])}
                  {/* {props.dashboard.tabs[tab.key]} */}
                </span>
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
      </Tab.Container>
    </div>
  );
}
